import React from "react";
import { Link } from "react-router-dom";
import logo from "../../src/assets/images/logo.png";
import footerBg from "../../src/assets/images/footer-bg.png"


const Footer = ({ user }) => {
  return (
    <footer className="relative z-10 bg-no-repeat bg-center-top bg-contain"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
          {/* E majta — Logo + desc + socials */}
          <div className="flex flex-col items-start gap-4 max-w-2xl">
            <div className="reveal reveal-up delay-1 flex items-center gap-2">
              <img src={logo} alt="logo" className="" />
              <p className="text-3xl text-white">MyRDP</p>
            </div>

            <p className="reveal reveal-up delay-2 text-sm text-[#FFFFFF] leading-relaxed">
              We provide high-performance RDP solutions designed for speed,
              stability, and security. Our infrastructure ensures seamless
              remote access, allowing businesses and individuals to work
              efficiently from anywhere with confidence and reliability.
            </p>

            <div className="reveal reveal-up delay-3 flex items-center gap-3 mt-2">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/myrdp.io"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-btn bg-[#FFFFFF08] w-[40px] h-[40px] rounded-full flex items-center justify-center shadow-[inset_0_12px_32px_-1.56px_#6795CA33] cursor-pointer"
              >
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_2529)">
                <g clip-path="url(#clip1_33_2529)">
                <g clip-path="url(#clip2_33_2529)">
                <mask id="mask0_33_2529"  maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
                <path d="M18.5513 0H0V18.5513H18.5513V0Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_33_2529)">
                <path d="M9.27566 1.66937C11.754 1.66937 12.0475 1.68024 13.0222 1.72372C13.928 1.76357 14.4171 1.91575 14.7432 2.04257C15.1744 2.20924 15.486 2.41214 15.8085 2.73462C16.1346 3.06071 16.3339 3.3687 16.5005 3.79987C16.6273 4.12597 16.7795 4.61874 16.8194 5.52094C16.8629 6.49923 16.8737 6.79272 16.8737 9.26743C16.8737 11.7458 16.8629 12.0393 16.8194 13.0139C16.7795 13.9198 16.6273 14.4089 16.5005 14.735C16.3339 15.1662 16.1309 15.4778 15.8085 15.8003C15.4824 16.1263 15.1744 16.3256 14.7432 16.4923C14.4171 16.6191 13.9244 16.7713 13.0222 16.8112C12.0439 16.8546 11.7504 16.8655 9.27566 16.8655C6.79732 16.8655 6.50383 16.8546 5.52916 16.8112C4.62334 16.7713 4.13419 16.6191 3.80809 16.4923C3.37692 16.3256 3.06531 16.1227 2.74284 15.8003C2.41674 15.4742 2.21746 15.1662 2.05079 14.735C1.92397 14.4089 1.7718 13.9161 1.73194 13.0139C1.68846 12.0356 1.67759 11.7422 1.67759 9.26743C1.67759 6.78909 1.68846 6.49561 1.73194 5.52094C1.7718 4.61511 1.92397 4.12597 2.05079 3.79987C2.21746 3.3687 2.42037 3.05709 2.74284 2.73462C3.06894 2.40852 3.37692 2.20924 3.80809 2.04257C4.13419 1.91575 4.62696 1.76357 5.52916 1.72372C6.50383 1.68024 6.79732 1.66937 9.27566 1.66937ZM9.27566 -0.000976562C6.75746 -0.000976562 6.44223 0.00989335 5.45307 0.053373C4.46753 0.0968526 3.78998 0.256278 3.203 0.484546C2.59066 0.723684 2.07253 1.03891 1.55802 1.55704C1.03989 2.07155 0.724661 2.58969 0.485523 3.1984C0.257255 3.789 0.0978292 4.46293 0.0543496 5.44847C0.0108699 6.44126 0 6.75648 0 9.27468C0 11.7929 0.0108699 12.1081 0.0543496 13.0973C0.0978292 14.0828 0.257255 14.7604 0.485523 15.3473C0.724661 15.9597 1.03989 16.4778 1.55802 16.9923C2.07253 17.5068 2.59066 17.8257 3.19938 18.0612C3.78998 18.2895 4.46391 18.4489 5.44945 18.4924C6.43861 18.5358 6.75384 18.5467 9.27203 18.5467C11.7902 18.5467 12.1055 18.5358 13.0946 18.4924C14.0802 18.4489 14.7577 18.2895 15.3447 18.0612C15.9534 17.8257 16.4715 17.5068 16.986 16.9923C17.5006 16.4778 17.8194 15.9597 18.0549 15.351C18.2832 14.7604 18.4426 14.0864 18.4861 13.1009C18.5296 12.1117 18.5404 11.7965 18.5404 9.2783C18.5404 6.76011 18.5296 6.44488 18.4861 5.45572C18.4426 4.47018 18.2832 3.79262 18.0549 3.20565C17.8267 2.58969 17.5114 2.07155 16.9933 1.55704C16.4788 1.04253 15.9607 0.723684 15.3519 0.488169C14.7613 0.259901 14.0874 0.100476 13.1019 0.0569963C12.1091 0.00989335 11.7939 -0.000976562 9.27566 -0.000976562Z" fill="white"/>
                <path d="M9.27636 4.50977C6.64584 4.50977 4.51172 6.64389 4.51172 9.27441C4.51172 11.9049 6.64584 14.0391 9.27636 14.0391C11.9069 14.0391 14.041 11.9049 14.041 9.27441C14.041 6.64389 11.9069 4.50977 9.27636 4.50977ZM9.27636 12.3651C7.56979 12.3651 6.18568 10.981 6.18568 9.27441C6.18568 7.56783 7.56979 6.18373 9.27636 6.18373C10.9829 6.18373 12.367 7.56783 12.367 9.27441C12.367 10.981 10.9829 12.3651 9.27636 12.3651Z" fill="white"/>
                <path d="M15.3419 4.32134C15.3419 4.9373 14.8419 5.4337 14.2295 5.4337C13.6136 5.4337 13.1172 4.93368 13.1172 4.32134C13.1172 3.70538 13.6172 3.20898 14.2295 3.20898C14.8419 3.20898 15.3419 3.709 15.3419 4.32134Z" fill="white"/>
                </g>
                </g>
                </g>
                </g>
                <defs>
                <clipPath id="clip0_33_2529">
                <rect width="19" height="19" fill="white"/>
                </clipPath>
                <clipPath id="clip1_33_2529">
                <rect width="19" height="19" fill="white"/>
                </clipPath>
                <clipPath id="clip2_33_2529">
                <rect width="19" height="19" fill="white"/>
                </clipPath>
                </defs>
                </svg>

              </a>

              {/* Telegram */}
              <a
                href="https://t.me/FocusedStudio"
                target="_blank"
                rel="noreferrer"
                aria-label="Telegram"
                className="social-btn bg-[#FFFFFF08] w-[40px] h-[40px] rounded-full flex items-center justify-center shadow-[inset_0_12px_32px_-1.56px_#6795CA33] cursor-pointer"
              >
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_2550)">
                <g clip-path="url(#clip1_33_2550)">
                <path d="M9.11496 11.7173L11.5798 14.5198C12.4931 15.5581 12.9497 16.0773 13.4277 15.9509C13.9057 15.8245 14.0696 15.1413 14.3974 13.7747L16.2157 6.19459C16.7206 4.08997 16.9729 3.03767 16.4118 2.51863C15.8507 1.9996 14.8782 2.38574 12.933 3.15804L3.90838 6.74105C2.35261 7.35873 1.57473 7.6676 1.52535 8.19832C1.52028 8.25262 1.5202 8.30733 1.52509 8.3616C1.57285 8.89253 2.34978 9.20405 3.90365 9.82683C4.6077 10.109 4.95974 10.2502 5.21213 10.5204C5.24051 10.5508 5.26779 10.5823 5.29394 10.6148C5.52648 10.9037 5.62574 11.283 5.8242 12.0413L6.19565 13.4608C6.38878 14.1988 6.48535 14.5679 6.73827 14.6182C6.99119 14.6685 7.2114 14.3625 7.65182 13.7505L9.11496 11.7173ZM9.11496 11.7173L8.87325 11.4655C8.59824 11.1788 8.4607 11.0355 8.4607 10.8574C8.4607 10.6793 8.59824 10.5359 8.87325 10.2493L11.5903 7.41755" stroke="white" stroke-width="0.760455" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </g>
                <defs>
                <clipPath id="clip0_33_2550">
                <rect width="19" height="19" fill="white"/>
                </clipPath>
                <clipPath id="clip1_33_2550">
                <rect width="19" height="19" fill="white"/>
                </clipPath>
                </defs>
                </svg>

              </a>
            </div>
          </div>

          {/* E djathta — Links */}
          <div className="reveal reveal-right delay-2">
            <h3 className="text-white font-semibold text-lg">Links</h3>
            <hr className="my-4 border-white/20 w-32" />

            <div className="flex gap-16 text-sm text-[#A2ADB5]">
              <div className="flex flex-col gap-4">
                <Link to="/signin" className="transition-colors hover:text-white">
                  Sign In
                </Link>
                <Link to="/signup" className="transition-colors hover:text-white">
                  Sign Up
                </Link>
                <Link
                  to="/forgot-password"
                  className="transition-colors hover:text-white"
                >
                  Forget Password
                </Link>
                <Link
                  to="/reset-password"
                  className="transition-colors hover:text-white"
                >
                  Reset Password
                </Link>
              </div>
              <div className="flex flex-col gap-4">
                <Link
                  to="/privacy"
                  className="transition-colors hover:text-white"
                >
                  Privacy Policy
                </Link>
                <Link to="/terms" className="transition-colors hover:text-white">
                  Terms Of Service
                </Link>
                <Link
                  to="/status"
                  className="transition-colors hover:text-white"
                >
                  System Status
                </Link>
                <Link to="/blog" className="transition-colors hover:text-white">
                  Blog
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Big text */}
        <p
          className="reveal reveal-zoom delay-3 text-[100px] sm:text-[200px] md:text-[280px] lg:text-[350px] text-center leading-none select-none pointer-events-none"
          style={{
            background: "linear-gradient(to bottom, #0B3BF0, transparent)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            opacity: 0.71,
          }}
        >
          MyRDP
        </p>

        {/* Copyright */}
        <p className=" text-center text-[#A2ADB5]">
          © 2026 Copyright - MyRDP | Made with love by{" "}
          <a
            href="https://focused-studio.com/"
            className="text-[#0B3BF0] hover:opacity-90 transition"
            target="_blank"
            rel="noreferrer"
          >
            focused-studio.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;